export default __webpack_public_path__ + "static/book-de504c909838bd045d5f61e02e0c6472.jpg";